import { apiSlice } from '../../app/api/apiSlice';

export const dashboardApiSlice = apiSlice.injectEndpoints({
  // tagTypes: ['Profile'],
  endpoints: (builder) => ({
    manpowerChart: builder.mutation({
      query: () => ({
        url: '/report/manpower',
        method: 'POST',
      }),
    }),
    manpowerByBranchChart: builder.mutation({
      query: (data) => ({
        url: '/report/manpower_branch',
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobrequestChart: builder.mutation({
      query: (data) => ({
        url: '/report/job_request',
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobrequestByBranchChart: builder.mutation({
      query: (data) => ({
        url: '/report/job_request_locationwise',
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobrequestByStatusChart: builder.mutation({
      query: (data) => ({
        url: '/report/job_request_status',
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobrequestByHandoverChart: builder.mutation({
      query: (data) => ({
        url: '/report/job_request_handover_status',
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobDescCountryChart: builder.mutation({
      query: (data) => ({
        url: '/report/job_description_countrywise_status',
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobDescLocationChart: builder.mutation({
      query: (data) => ({
        url: '/report/job_description_locationwise_status',
        method: 'POST',
        body: { ...data },
      }),
    }),
    jobDescStatusChart: builder.mutation({
      query: (data) => ({
        url: '/report/job_description_statuswise',
        method: 'POST',
        body: { ...data },
      }),
    }),
    skillCaptureStatusChart: builder.mutation({
      query: (data) => ({
        url: '/report/skill_capture_status',
        method: 'POST',
        body: { ...data },
      }),
    }),
    sourcingStatusChart: builder.mutation({
      query: (data) => ({
        url: '/report/sourcing_status',
        method: 'POST',
        body: { ...data },
      }),
    }),
    screeningStatusChart: builder.mutation({
      query: (data) => ({
        url: '/report/screening_status',
        method: 'POST',
        body: { ...data },
      }),
    }),
    //added by lakshmi
    SourcingQualityReportChart: builder.mutation({
      query:(data) => ({
        url:'report/sourcing_quality_report',
        method: 'POST',
        body:{...data},
      }),
    }),
    screeningQualityReportChart: builder.mutation({
      query:(data) => ({
        url:'report/screening_quality_report',
        method:'POST',
        body: {...data},
      }),
    }),
    interviewHiringReportChart: builder.mutation({
      query:(data) => ({
        url:'report/interview_hiring_report',
        method:'POST',
        body: {...data},
      }),
    }),
    offerDroppedOutReportChart: builder.mutation({
      query:(data) => ({
        url: 'report/offer_droppedout_report',
        method:'POST',
        body:{...data},
      }),
    }),
    interviewLevelReportChart: builder.mutation({
      query: (data) =>({
        url: 'report/interview_stages_report',
        method:'POST',
        body:{...data},
      }),
    }),
    recruitmentProcessDelayReportChart : builder.mutation({
      query: (data) => ({
        url : 'report/recruitment_process_delay_report',
        method:'POST',
        body:{...data},
      }),
    }),
    joiningProcessReportChart : builder.mutation({
      query: (data) => ({
        url: 'report/joining_process_report',
        method: 'POST',
        body : {...data},
      }),
    }),
    //sourcing_timeline_candidatewise
    sourcingTimelineStatusCandidatewise : builder.mutation({
      query: (data) => ({
        url: 'report/sourcing_delay_candidatewise',
        method: 'POST',
        body: {...data},
      }),
    }),
    //screening_timeline_candidatewise
    screeningTimelineStatusCandidatewise : builder.mutation({
      query: (data) => ({
        url: 'report/screening_delay_candidatewise',
        method: 'POST',
        body: {...data},
      }),
    }),
    //interview_timeline_candidatewise
    interviewTimelineStatusCandidatewise : builder.mutation({
      query: (data) => ({
        url: 'report/interview_delay_candidatewise',
        method: 'POST',
        body: {...data},
      }),
    }),
    //offer_timeline_candidatewise
    offerTimelineStatusCandidatewise : builder.mutation({
      query: (data) => ({
        url: 'report/offer_delay_candidatewise',
        method: 'POST',
        body: {...data},
      }),
    }),
    //Followup_timeline_candidatewise
    followupTimelineStatusCandidatewise : builder.mutation({
      query: (data) => ({
        url: 'report/followup_delay_candidatewise',
        method: 'POST',
        body: {...data},
      }),
    }),
    //handover_timeline_candidatewise
    handoverTimelineStatusCandidatewise : builder.mutation({
      query: (data) => ({
        url: 'report/handover_delay_candidatewise',
        method: 'POST',
        body: {...data},
      }),
    }),    
    //end here
  }),
});

export const {
  useManpowerChartMutation,
  useManpowerByBranchChartMutation,
  useJobrequestChartMutation,
  useJobrequestByBranchChartMutation,
  useJobrequestByStatusChartMutation,
  useJobrequestByHandoverChartMutation,
  useJobDescCountryChartMutation,
  useJobDescLocationChartMutation,
  useJobDescStatusChartMutation,
  useSkillCaptureStatusChartMutation,
  useSourcingStatusChartMutation,
  useScreeningStatusChartMutation,
  //added by lakshmi
  useSourcingQualityReportChartMutation,
  useScreeningQualityReportChartMutation,
  useInterviewHiringReportChartMutation,
  useOfferDroppedOutReportChartMutation,
  useInterviewLevelReportChartMutation,
  useRecruitmentProcessDelayReportChartMutation,
  useJoiningProcessReportChartMutation,
  useSourcingTimelineStatusCandidatewiseMutation,
  useScreeningTimelineStatusCandidatewiseMutation,
  useInterviewTimelineStatusCandidatewiseMutation,
  useOfferTimelineStatusCandidatewiseMutation,
  useFollowupTimelineStatusCandidatewiseMutation,
  useHandoverTimelineStatusCandidatewiseMutation,
  //end here 
} = dashboardApiSlice;
